import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";


// API calls

export const fetchPurchaseReqList = createAsyncThunk("fetchPurchaseReqList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.purchaseRequestList}?page=${data.page}&limit=${data.limit}&sort_by=${data.sort_by}&order_by=${data.order_by}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}`);
  if (response?.status === 200 || (response?.status === 400 && response?.data?.message === "No data found!")) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.purchaseRequestList} ====> ${JSON.stringify(
        response?.data?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchIndividualPurchaseReq = createAsyncThunk("fetchIndividualPurchaseReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualPurchaseRequest}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.individualPurchaseRequest} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchMaintenanceReqList = createAsyncThunk("fetchMaintenanceReqList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.maintenanceRequestList}?sortColumn=${data.order_by}&sort=${data.sort_by}&page=${data.page}&size=${data.limit}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&company_id=${data?.company_id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.maintenanceRequestList} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});
export const fetchIndividualMaintenanceReq = createAsyncThunk("fetchIndividualMaintenanceReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualMaintenanceRequest}/${data?.id}`);
  if (response?.status === 200 || response?.status === 400) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    console.log(
      `Error ===> ${API_END_POINTS.individualMaintenanceRequest} ====> ${JSON.stringify(
        response?.message
      )}`
    );
  }
  return response?.data;
});

export const fetchCallReqList = createAsyncThunk("fetchCallReqList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.callRequestList}?sortColumn=${data.order_by}&sort=${data.sort_by}&page=${data.page}&size=${data.limit}&from_date=${data?.fromDate}&${data?.toDate && `to_date=${data?.toDate}`}&company_id=${data?.company_id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.callRequestList} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualCallReq = createAsyncThunk("fetchIndividualCallReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualCallRequest}/${data?.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyServiceHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchConditionMonitoringReqList = createAsyncThunk("conditionMonitoringReqList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.conditionMonitoringRequestList}?sortColumn=${data.order_by}&sort=${data.sort_by}&page=${data.page}&size=${data.limit}&from_date=${data?.fromDate}&${data?.toDate && `to_date=${data?.toDate}`}&company_id=${data?.company_id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.callRequestList} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualConditionMonitoringReq = createAsyncThunk("fetchIndividualConditionMonitoringReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualConditionMonitoringReq}/${data?.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyServiceHistory} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchCreditReqList = createAsyncThunk("fetchCreditReqList", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.creditRequestList}?sortColumn=${data.order_by}&sort=${data.sort_by}&page=${data.page}&size=${data.limit}&from_date=${data?.fromDate}&${data?.toDate ? `to_date=${data?.toDate}` : ""}&company_id=${data?.company_id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.creditRequestList} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const fetchIndividualCreditReq = createAsyncThunk("fetchIndividualCreditReq", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.individualCreditRequest}/${data?.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.individualCreditRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const deleteCompany = createAsyncThunk("deleteCompany", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().delete(`${API_END_POINTS.deleteCompany}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.deleteCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const updateCompanyStatus = createAsyncThunk("updateCompanyStatus", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.companyStatusChange}/${data.status}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.companyStatusChange} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const closeCallRequest = createAsyncThunk("closeCallRequest", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.closeCallRequest}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.closeCallRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const closeMaintenanceRequest = createAsyncThunk("closeMaintenanceRequest", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.closeMaintenanceRequest}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.closeMaintenanceRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const closeConditionMonitoringRequest = createAsyncThunk("closeConditionMonitoringRequest", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.closeConditionMonitoringReq}/${data.id}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.closeCallRequest} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const editUser = createAsyncThunk("editUser", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editUser}`, data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const addCredit = createAsyncThunk("addCredit", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().put(`${API_END_POINTS.editCompany}`, data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.editCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const checkEmail = createAsyncThunk("checkEmail", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.checkEmail}?email=${data.mail}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.checkEmail} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const mapExistingUser = createAsyncThunk("mapExistingUser", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().get(`${API_END_POINTS.mapExistingUser}`);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.mapExistingUser} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});

export const addCompany = createAsyncThunk("addCompany", async ({ data, callBack }) => {
  // api hit
  const response = await APIKit().post(`${API_END_POINTS.addCompany}`, data);
  if (response?.status === 200) {
    callBack(response?.data);
  } else {
    notifyError(response?.data?.message);
    // alert(JSON.stringify(response));
    console.log(
      `Error ===> ${API_END_POINTS.addCompany} ====> ${JSON.stringify(
        response
      )}`
    );
  }
  return response?.data;
});


export const requestManagementSlice = createSlice({
  name: "requestManagement",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {

    builder
      .addCase(fetchPurchaseReqList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchPurchaseReqList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchPurchaseReqList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualPurchaseReq.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualPurchaseReq.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualPurchaseReq.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchMaintenanceReqList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchMaintenanceReqList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchMaintenanceReqList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualMaintenanceReq.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualMaintenanceReq.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualMaintenanceReq.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCallReqList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCallReqList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCallReqList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualCallReq.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualCallReq.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualCallReq.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchCreditReqList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchCreditReqList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchCreditReqList.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(closeCallRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(closeCallRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(closeCallRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(closeMaintenanceRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(closeMaintenanceRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(closeMaintenanceRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(fetchIndividualCreditReq.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(fetchIndividualCreditReq.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(fetchIndividualCreditReq.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(deleteCompany.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(deleteCompany.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(deleteCompany.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(updateCompanyStatus.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(updateCompanyStatus.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(updateCompanyStatus.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(editUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(editUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(editUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(addCredit.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(addCredit.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(addCredit.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(checkEmail.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(checkEmail.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(checkEmail.rejected, (state, action) => {
        state.isLoading = "failed";
      });
    builder
      .addCase(mapExistingUser.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(mapExistingUser.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(mapExistingUser.rejected, (state, action) => {
        state.isLoading = "failed";
      });

  },
});

export default requestManagementSlice.reducer;
